// Added By mlveda--
// Custom Owl - carousel Script apply only on responsive script start
// $(window).resize(function(){
//   OwlCarouselInit();
// });
$(document).ready(function() {
function OwlCarouselInit(){
  if( $("#testimonial-carousel").length) {
    $('#testimonial-carousel').owlCarousel({
        loop: true,
        margin: 0,
        nav: true,
        items:1,
        dots:false,
        mouseDrag:true,
        touchDrag:true,
    });
  }
  
  if($("#relPrd").length) {
    $('#relPrd').owlCarousel({
        loop: true,
        margin: 10,
        nav: true,
        // items:4,
        dots:false,
        mouseDrag:true,
        touchDrag:true,
        responsive:{
          0:{
              items:1
          },
          600:{
              items:2
          },
          1000:{
              items:4
          }
      }
    });
    //$owl.trigger('refresh.owl.carousel');
  }
}
  
  let intervalId = setInterval(function() {
     OwlCarouselInit();
  }, 1000);

  setTimeout(function() {
    clearInterval(intervalId);
  }, 5000);
  
  // setInterval(function() {
  // OwlCarouselInit();
  // },1000); 
});





